import router from '@client-frontend/router.js'
import { isRealtimeEnabled } from '@client-frontend/helpers/realtime'
import { atom } from 'nanostores'

export const $realtime_enabled = atom<boolean>(isRealtimeEnabled())

// subscribe to router navigation events and update the $realtime_enabled value
router.onNavigation(() => {
	$realtime_enabled.set(isRealtimeEnabled())
})
